<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari transaksi"
        search-action="transaction/getTransactions"
        :payload="{ ...currentTabsPayload }"
      >
        <template #action>
          <b-button
            v-if="false"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :disabled="isExporting"
            @click.prevent="handleExport"
          >
            <b-spinner
              v-if="isExporting"
              small
              class="mr-50"
            />
            <feather-icon
              v-else
              icon="FileTextIcon"
              class="mr-50"
            />
            <span class="text-nowrap"> Export Data</span>
          </b-button>
        </template>
      </table-header>
    </b-card>

    <b-card no-body>
      <b-overlay :show="loadingOverlay">
        <tabs-menu
          :menu="menuTabs"
          :active="activeTabs"
          class="mb-0"
          compact
        >
          <template #action>
            <b-dropdown
              size="lg"
              variant="white"
              toggle-class="text-decoration-none btn-icon"
              no-caret
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreHorizontalIcon"
                  size="16"
                />
              </template>
              <b-dropdown-item @click="refreshList">
                Refresh
              </b-dropdown-item>
              <b-dropdown-item
                v-if="activeTabs === 5"
                @click="copyTransactionList"
              >
                Salin daftar pickup
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </tabs-menu>

        <b-skeleton-table
          v-if="isLoading"
          :rows="5"
          :columns="5"
        />

        <b-table
          v-if="!isLoading"
          ref="refInvoiceListTable"
          :items="transactions.data"
          responsive
          :fields="tableFields"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
          thead-class="text-nowrap"
          class="position-relative"
          hover
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @row-clicked="getDetail"
        >

          <!-- Column: Ringkasan -->
          <template #cell(ringkasan)="data">
            <div class="mb-25 d-flex align-items-center flex-nowrap">
              <a
                :href="`/transactions/${data.item.id}/detail`"
                target="_blank"
                class="text-dark font-weight-bold"
              >
                {{ data.item.invoice_number ? data.item.invoice_number : '-' }}
              </a>
              <feather-icon
                v-b-tooltip.hover.top="'Salin No Invoice'"
                icon="CopyIcon"
                size="16"
                class="copy-btn ml-25"
                @click.stop="onCopy(data.item.invoice_number, 'No Invoice')"
              />
            </div>
            <small>{{ data.item.accepted_at ? formatDate(data.item.accepted_at) : formatDate(data.item.created_at) }} {{ data.item.accepted_at ? formatTime(data.item.accepted_at) : formatTime(data.item.created_at) }}</small>
          </template>

          <!-- Column: Customer -->
          <template #cell(customer)="data">
            <div class="text-truncate">
              <div
                class="mb-25 font-weight-bold text-truncate"
                style="max-width: 200px"
              >
                {{ data.item.buyer ? data.item.buyer.name : 'Akun tidak tersedia' }}
              </div>
              <div
                v-if="data.item.delivery && (!data.item.buyer || data.item.buyer.name !== data.item.delivery.consignee_name)"
                class="text-truncate s-12"
                style="max-width: 200px"
              >
                Penerima: <span class="font-weight-bold">{{ data.item.delivery.consignee_name }}</span>
              </div>
            </div>
          </template>

          <!-- Column: Merchant -->
          <template #cell(merchant)="data">
            <div class="form-row align-items-center">
              <div class="col-auto">
                <b-img
                  rounded
                  width="36"
                  :src="linkStaging(data.item.merchant.image_url, 50, 50)"
                  alt=""
                />
              </div>
              <div class="col text-truncate">
                {{ data.item.merchant ? data.item.merchant.name : '-' }}
              </div>
            </div>
          </template>

          <!-- Column: Total Transaction -->
          <template #cell(totalTransaction)="data">
            <span v-if="$store.state.auth.userData.role === 'merchant'">{{ data.item.total_transaction ? toCurrency(data.item.total_transaction) : '-' }}</span>
            <span v-if="$store.state.auth.userData.role === 'admin'">{{ data.item.total_payment ? toCurrency(data.item.total_payment) : '-' }}</span>
          </template>

          <!-- Column: Total Item -->
          <template #cell(totalItem)="data">
            {{ data.item.items ? data.item.items.length : '-' }} Items
          </template>

          <!-- Column: Total Item -->
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status && tabStatusList.findIndex(el => el.value === data.item.status) !== -1"
              :variant="tabStatusList.find(el => el.value === data.item.status).color"
            >
              {{ tabStatusList.find(el => el.value === data.item.status).title }}
            </b-badge>
            <b-badge
              v-else
              variant="secondary"
            >
              Belum Dibayar
            </b-badge>
          </template>

        </b-table>

        <div class="mx-2 mb-2">
          <pagination
            :data="transactions.meta"
            action="transaction/getTransactions"
            :payload="{ ...currentTabsPayload }"
          />
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BCard,
  BTable,
  BBadge,
  BButton,
  VBTooltip,
  BSpinner, BImg, BDropdown, BDropdownItem,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import Pagination from '@/layouts/components/custom/Pagination.vue'
import TabsMenu from '@/layouts/components/custom/TabsMenu.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BSkeletonTable,
    BCard,
    BTable,
    BImg,
    BBadge,
    BOverlay,
    BButton,
    BSpinner,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    Pagination,
    TabsMenu,
    TableHeader,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      sortBy: 'ringkasan',
      sortDesc: false,
      loadingOverlay: false,
      tableFields: [
        {
          key: 'ringkasan', label: 'Ringkasan', stickyColumn: true, sortable: true,
        },
        { key: 'customer', label: 'Pelanggan' },
        { key: 'merchant', label: 'Brand' },
        { key: 'totalTransaction', label: this.$store.state.auth.userData.role === 'admin' ? 'Total Tagihan' : 'Total Transaksi' },
        { key: 'status', label: 'Status' },
      ],
      isPending: false,
      isExporting: false,
    }
  },
  computed: {
    ...mapState('transaction', [
      'transactions',
      'tabStatusList',
      'filterVoucher',
      'summary',
      'isLoading',
    ]),
    menuTabs() {
      return [
        {
          access: null,
          title: 'Belum Dibayar',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[payment_statuses]': 'unpaid',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: this.summary.unpaid.toString(),
        },
        {
          access: null,
          title: 'Sudah Dibayar',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[payment_statuses]': 'paid',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: null,
        },
        {
          access: null,
          title: 'Tidak Dibayar',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[payment_statuses]': 'cancelled',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: null,
        },
        {
          access: null,
          title: 'Diproses',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[statuses]': 'accepted',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: this.summary.accepted.toString(),
        },
        {
          access: null,
          title: 'Req. Pickup',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[statuses]': 'pickup_requested',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: this.summary.pickup_requested.toString(),
        },
        {
          access: null,
          title: 'Dikirim',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[statuses]': 'pickedup',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: this.summary.pickedup.toString(),
        },
        {
          access: null,
          title: 'Selesai',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[statuses]': 'delivered',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: null,
        },
        {
          access: null,
          title: 'Batal',
          action: 'transaction/getTransactions',
          payload: {
            filter: {
              'filter[statuses]': 'cancelled',
            },
            sort: '-accepted_at',
          },
          otherAction: () => { this.onClearQueryLocal() },
          otherQuery: {
            keyword: this.query.keyword,
            sort: '-accepted_at',
          },
          counter: null,
        },
      ]
    },
    activeTabs() {
      return !this.$route.query.tab ? 4 : parseInt(this.$route.query.tab, 0)
    },
    query() {
      return this.$route.query
    },
    currentTabsPayload() {
      return this.menuTabs[this.activeTabs - 1].payload
    },
  },
  watch: {
    async sortDesc(value) {
      if (value) {
        await this.$router.push({ query: { ...this.$route.query, sort: '-accepted_at' } }).catch(() => {})
      } else {
        await this.$router.push({ query: { ...this.$route.query, sort: 'accepted_at' } }).catch(() => {})
      }

      // do not trigger load transactions on init
      if (!this.transactions.meta.current_page) {
        return
      }

      await this.getTransactions({ ...this.query, ...this.currentTabsPayload, sort: this.$route.query.sort || undefined })
    },
    activeTabs() {
      this.initSort()
    },
  },
  async mounted() {
    this.initSort()

    await this.onInitLastQueryLocal() // global function
    await this.getTransactions({ ...this.query, ...this.currentTabsPayload, sort: this.$route.query.sort || undefined })
    this.getCounter()
  },
  methods: {
    ...mapActions('transaction', [
      'exportTransactions',
      'getTransactions',
      'getRawTransactions',
      'getSummaryTransaction',
    ]),
    async getDetail(data) {
      await this.onSaveLastQueryLocal() // global function
      this.$router.push(`/transactions/${data.id}/detail`)
    },
    async refreshList() {
      await this.getTransactions({ ...this.query, ...this.currentTabsPayload, sort: this.$route.query.sort || undefined })
      this.getCounter()
    },
    async handleExport() {
      this.isExporting = true
      await this.exportTransactions()
      this.isExporting = false
    },
    async copyTransactionList() {
      try {
        let data = null

        if (this.transactions.meta && this.transactions.meta.last_page > 1) {
          this.loadingOverlay = true

          const res = await this.getRawTransactions({
            ...this.query,
            ...this.currentTabsPayload,
            sort: this.$route.query.sort || undefined,
            limit: 1000,
            page: null,
          })

          data = res.data
        } else {
          data = this.transactions.data
        }

        // Grouping data by merchant name using reduce
        const grouped = data.reduce((acc, item) => {
          const merchantName = item.merchant.name
          const current = acc[merchantName] || { count: 0, insuranceCount: 0 }

          acc[merchantName] = {
            count: current.count + 1,
            insuranceCount: current.insuranceCount + (item.use_delivery_insurance ? 1 : 0),
          }

          return acc
        }, {})

        // Create the final string output
        const output = Object.entries(grouped)
          .sort(([, a], [, b]) => b.count - a.count)
          .map(([name, info]) => {
            let line = `- ${name}: ${info.count} paket`
            if (info.insuranceCount > 0) {
              line += ` (${info.insuranceCount} Asuransi)`
            }
            return line
          })
          .join('\n')

        // Copy to clipboard
        navigator.clipboard.writeText(output)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                icon: 'CheckIcon',
                title: 'Berhasil!',
                text: 'Daftar transaksi berhasil disalin.',
                variant: 'success',
              },
            })
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                icon: 'BellIcon',
                title: 'Gagal',
                text: 'Daftar transaksi gagal disalin.',
                variant: 'danger',
              },
            })
          })
      } finally {
        this.loadingOverlay = false
      }
    },
    initSort() {
      if (this.query.sort) {
        if (this.query.sort === 'accepted_at') this.sortDesc = false
        if (this.query.sort === '-accepted_at') this.sortDesc = true
      }
    },
    getCounter() {
      this.getSummaryTransaction()
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #7367f0;

.product-info {
  display: flex;
  &__image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
  }
}

.product-list {
  &__tabs {
    display: flex;
  }
  &__filters {
    padding: 16px 20px;
    font-size: 14px !important;
  }
  &__footer {
    padding: 16px 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.tab-item {
  padding: 12px 28px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #bdbdbd;
  &:hover {
    cursor: pointer;
    color: $primary;
  }
  &.active {
    color: $primary;
    border-color: $primary;
  }
}

.copy-btn {
  cursor: pointer;
  padding-left: 2px;
}

a:not(:hover) {
  color: initial;
}

a:hover {
  text-decoration: underline;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
